module.exports = __webpack_public_path__ + "media/featured_internships/featured-internships_header_620x170-a011e7fd.png";